import { Loading, Section } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useParams } from "react-router";
import { integrationService } from "../shared/api/integrationService";
import { DresoConfigForm } from "./DresoConfigForm";

export const IntegrationDetailPage: FC = () => {
	const { id = "" } = useParams();

	const { data: integration, isLoading } = useQuery({
		queryKey: integrationService.showKey(id),
		queryFn: () => integrationService.show(id).then((r) => r.data.data),
	});

	if (isLoading || !integration) {
		return <Loading />;
	}

	return <Section>{integration.type === "dreso" && <DresoConfigForm integration={integration} />}</Section>;
};
